"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = exports.initialSearchByOption = exports.initialFilterOptions = exports.initialOrderByOptions = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const Actions = require("../../actionTypes/activity/list");
exports.initialOrderByOptions = {
    orderBy: 'id',
    order: 'desc'
};
exports.initialFilterOptions = {};
exports.initialSearchByOption = {
    from: null,
    to: null,
    user: null,
    activity: null,
    limit: 350,
    offset: 0
};
exports.initialState = {
    status: 'STANDBY',
    error: undefined,
    activities: [],
    types: [],
    total: 0
};
//#endregion
//#region LENS
const statusLens = monocle.Lens.fromProp('status');
const activitiesLens = monocle.Lens.fromProp('activities');
const errorLens = monocle.Lens.fromProp('error');
const totalLens = monocle.Lens.fromProp('total');
const methods = {};
exports.methods = methods;
methods[Actions.FETCH_ACTIVITIES_REQUEST] = (state, action) => {
    return statusLens.set('FETCHING')(state);
};
methods[Actions.FETCH_ACTIVITIES_SUCCESS] = (state, action) => {
    return fp.function.compose(statusLens.set('FETCHED'), totalLens.set(action.payload.activities.length > 0
        ? parseInt(action.payload.activities[0].full_count, 10)
        : 0), activitiesLens.set(action.payload.activities), totalLens.set(action.payload.activities.length))(state);
};
methods[Actions.FETCH_ACTIVITIES_FAILURE] = (state, action) => fp.function.compose(statusLens.set('FAILED'), errorLens.set(action.payload))(state);
methods[Actions.CLEAR] = () => (Object.assign({}, exports.initialState));
methods[Actions.FETCH_ACTIVITY_TYPES_SUCCESS] = (state, action) => {
    return Object.assign(Object.assign({}, state), { types: action.payload.rows });
};
//# sourceMappingURL=list.js.map